import React from 'react'
import { Switch, Route } from "react-router-dom"
import TourPackageController from './tour-packages/tour-package.controller'
import HotelController from './hotels/hotel.controller'
import FlightOfferController from './flight-offers/flight-offer.controller'
import VisaPackageController from './visa-packages/visa-package.controller'

const SecurityController = () => {
    return (
        <Switch>
            <Route path="/content/tour-packages" component={TourPackageController} />
            <Route path="/content/hotels" component={HotelController} />
            <Route path="/content/flight-offers" component={FlightOfferController} />
            <Route path="/content/visa-packages" component={VisaPackageController} />
        </Switch>
    )
}

export default SecurityController
